import { render, staticRenderFns } from "./DeviceLabel.vue?vue&type=template&id=40fd885a&scoped=true"
import script from "./DeviceLabel.vue?vue&type=script&lang=js"
export * from "./DeviceLabel.vue?vue&type=script&lang=js"
import style0 from "./DeviceLabel.vue?vue&type=style&index=0&id=40fd885a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fd885a",
  null
  
)

export default component.exports